import apiClient from '../apiClient';
import { GET_USER_ROLE_BY_BEARER_URL } from '../apiUrl';

const getUserRoleByBearerApi = () => {
  return apiClient.get(GET_USER_ROLE_BY_BEARER_URL);
};

export default getUserRoleByBearerApi;
